import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { PoBreadcrumb, PoDatepickerIsoFormat, PoDialogService, PoDisclaimerGroupComponent, PoDynamicFormField, PoLookupColumn, PoModalAction, PoModalComponent, PoNotificationService, PoPageFilter, PoPageSlideComponent, PoSearchFilterMode, PoTableColumn } from '@po-ui/ng-components';
import { PoStorageService } from '@po-ui/ng-storage';
import { Zpr } from 'src/app/interface/zpr';
import { ZprLookupService } from 'src/app/service/zpr-lookup.service';
import { FiltroGuaritaListaNotas } from '../filtro/filtro-lista-notas-faturamento-guarita';
import { getNotaDtoDefault, getPedidoGuaritaDefault, getStatusFaturamentoDefault, NotaDto, PedidoGuaritaDto, StatusFaturamento } from '../../interface/pedido';
import { DanfeService } from '../../service/danfe-service';
import { PedidoService } from '../../service/pedido.service';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  selector: 'app-faturamento-guarita-lista-notas',
  templateUrl: './faturamento-guarita-lista-notas.component.html',
  styleUrls: ['./faturamento-guarita-lista-notas.component.css']
})
export class FaturamentoGuaritaListaNotasComponent implements OnInit {

  tabelaPrincipalItens: Array<any> = [];
  tabelaPrincipalFiltro: FiltroGuaritaListaNotas;

  formatExtended: PoDatepickerIsoFormat = PoDatepickerIsoFormat.Extended;

  poSearchFilterMode: PoSearchFilterMode = PoSearchFilterMode.contains;

  pedidoSelecionado: PedidoGuaritaDto = getPedidoGuaritaDefault();

  guarita: string = '';
  guaritaNome: string = '';

  guaritaAdvancedFilters: Array<PoDynamicFormField>;
  guaritaColumnsFilters: Array<PoLookupColumn>;
  guaritaFieldFormaterFilters: (value: Zpr) => string;

  notaDeletada: NotaDto = getNotaDtoDefault();
  statusCancelamento: StatusFaturamento = getStatusFaturamentoDefault();

  podeCancelar: boolean = false;

  constructor(
    private router: Router,
    private poStorageService: PoStorageService,
    private pedidoService: PedidoService,
    private danfeService: DanfeService,
    private poDialog: PoDialogService,
    private poNotificationService: PoNotificationService,
    public zprLookupService: ZprLookupService,
    private authService: AuthService,
  ) {

    this.tabelaPrincipalFiltro = new FiltroGuaritaListaNotas(this.poStorageService);

    this.zprLookupService.grupo      = 'GUARITA';
    this.guaritaAdvancedFilters      = this.zprLookupService.getAdvancedFilter();
    this.guaritaColumnsFilters       = this.zprLookupService.getColumnsFilter();
    this.guaritaFieldFormaterFilters = this.zprLookupService.getFieldFormater;

  }

  @ViewChild('advancedFilterModal', { static: true }) advancedFilterModal!: PoModalComponent;
  @ViewChild('pageSlide', { static: true }) pageSlide!: PoPageSlideComponent;
  @ViewChild('modalStatusCancelamento', { static: true }) modalStatusCancelamento!: PoModalComponent;

  ngOnInit(): void {

    this.authService.validaPrivilegio(["PO_CANCELAR_NOTA_GUARITA", "PORTAL_ADMINISTRADOR"]).then((ret) => {
      this.podeCancelar = ret;

      if (this.tabelaPrincipalFiltro.dados.CC5GUARITA != '') {
        this.tabelaPrincipalLoad();
      }

    });

  }

  tabelaPrincipalLoad(): void {
    this.tabelaPrincipalFiltro.setStorage();

    this.guarita = this.tabelaPrincipalFiltro.dados.CC5GUARITA;

    this.zprLookupService.getObjectByValue(this.guarita.trim()).subscribe((ret) => {
      this.guaritaNome = ret.CZPRGENERI;
    });

    this.pedidoService.listaNotas(this.guarita, this.tabelaPrincipalFiltro.dados).subscribe((lista) => {
      this.tabelaPrincipalItens = lista.items.map((item) => {

        let actions = [''];
        let CSTATUS = '';

        if (item.CF2DELET == 'N') {
          actions = ['view'];
          let dataHoje = new Date();
          let dataOntem = new Date();
          dataOntem.setDate(dataOntem.getDate() - 1);


          let horaNota = parseInt(item.CF2HORA.substring(0,2)) + 1;
          let anoNota = 0;
          let mesNota = 0;
          let diaNota = 0;

          if (item.DF2EMISSAO) {
            let dateString = item.DF2EMISSAO?.toString();
            anoNota = parseInt(dateString?.substring(0,4));
            mesNota = parseInt(dateString?.substring(5,7));
            diaNota = parseInt(dateString?.substring(8,10));
          }

          if (item.CF2FIMP == 'S' && item.DF2EMISSAO && ((anoNota == dataHoje.getFullYear() && mesNota == (dataHoje.getMonth() + 1) && diaNota == dataHoje.getDate()) || anoNota == dataOntem.getFullYear() && mesNota == (dataOntem.getMonth() + 1) && diaNota == dataOntem.getDate() && horaNota > dataHoje.getHours())) {
            actions = ['view', 'cancelar'];
          }

          CSTATUS = item.CF2FIMP;
        } else {
          if (item.CF3CODRSEF == '101') {
            CSTATUS = 'C'; //CANCELADA
          } else {
            CSTATUS = 'E';
          }
        }

        return { ...item, CSTATUS: CSTATUS, favorite: actions };
      });
    });
  }

  public readonly tabelaPrincipalColunas: Array<PoTableColumn> = [
    {property: 'CF2DOC'       , label: 'Documento'    },
    {property: 'CF2SERIE'     , label: 'Série'        },
    {property: 'CC5NUM'       , label: 'Pedido'       },
    {property: 'CC5CLIENTE'   , label: 'Cod Cliente'  },
    {property: 'CC5LOJACLI'   , label: 'Loja'         },
    {property: 'CA1NREDUZ'    , label: 'Cliente'      },
    {property: 'DF2EMISSAO'   , label: 'Emissão' , type: 'date', format: 'dd/MM/yyyy'},
    {property: 'CF2HORA'      , label: 'Hora'         },
    {property: 'CSTATUS'      , label: 'Status'  , width: '15%', type: 'label',
      labels: [
        { value: '', color: 'color-01',  label: 'Em transmissão'  },
        { value: 'N', color: 'color-09',  label: 'Rejeitada'  },
        { value: 'S', color: 'color-05',  label: 'Transmitida'    },
        { value: 'C', color: 'color-08',  label: 'Cancelada'  },
        { value: 'E', color: 'color-07',  label: 'Cancelada - Não Transmitida'  },
      ]
    },

    {property: 'favorite'     , label: '...'     , width: '10%', type: 'icon',
      icons: [
        {
          action: this.view.bind(this),
          icon: 'po-icon-pdf',
          tooltip: 'Danfe',
          value: 'view',
          disabled: this.desabilitaDanfe.bind(this)
        },
        {
          action: this.cancelarNota.bind(this),
          icon: 'po-icon-clear-content',
          tooltip: 'Cancelar Nota',
          value: 'cancelar',
          disabled: this.desabilitaCancelar.bind(this)
        },
      ]
    }
  ];

  public readonly breadcrumb: PoBreadcrumb = {
    items: [
      { label: 'Notas Guarita', action: this.goHome.bind(this) },
      { label: 'Lista' }
    ]
  };

  view(row: NotaDto): void {
    this.danfeService.getDanfeII(row.CF2SERIE, row.CF2DOC).subscribe((res) => {
      var file = new Blob([res], {type: 'application/pdf'});
      var fileName = `${row.CF2CHVNFE}.pdf`;
      var a = document.createElement("a");
      document.body.appendChild(a);

      var fileURL = window.URL.createObjectURL(file);
      a.href = fileURL;
      a.download = fileName;
      a.click();
    });
  }

  cancelarNota(row: NotaDto): void {
    this.poDialog.confirm({
      title: 'Confirmar Cancelamento',
      message: 'Deseja realmente cancelar a nota no SEFAZ?',
      confirm: () => this.confirmaCancelarNota(row)
    });
  }

  confirmaCancelarNota(row: NotaDto): void {
    this.pedidoService.cancelarNF(row.NREGSF2).subscribe((ret) => {
      this.notaDeletada = row;
      this.tabelaPrincipalLoad();
      this.atualizaStatusCancelamentoF();
      this.modalStatusCancelamento.open();
    })
  }

  desabilitaDanfe(row: NotaDto): boolean {
    return row.CF2FIMP != 'S';
  }

  desabilitaCancelar(row: NotaDto): boolean {
    return !this.podeCancelar;
  }

  public readonly atualizaStatusCancelamento: PoModalAction = {
    action: () => {
      this.atualizaStatusCancelamentoF();
    },
    label: 'Atualizar'
  };

  atualizaStatusCancelamentoF(): void {
    this.pedidoService.statusCancelamento(this.notaDeletada.CF2DOC, this.notaDeletada.CF2SERIE, this.notaDeletada.CC5CLIENTE, this.notaDeletada.CC5LOJACLI).subscribe((ret) => {
      this.statusCancelamento = ret;
    })
  }

  goHome(): void {
    this.router.navigateByUrl('');
  }

  //################################################################//
  // FILTRO
  //################################################################//
  public readonly filterSettings: PoPageFilter = {
    advancedAction: this.advancedFilterActionModal.bind(this),
  };

  advancedFilterActionModal(): void {
    this.advancedFilterModal.open();
  }

  public readonly advancedFilterPrimaryAction: PoModalAction = {
    action: () => {
      this.advancedFilterModal.close();
      this.tabelaPrincipalLoad();
    },
    label: 'Aplicar Filtros'
  };


}
